import {
  Randomization,
  CaseFacility,
  OrganApproval,
  TrialAnsweredQuestionModel,
  ReallocationData,
  OutcomeType,
} from '@/api/apis/case';
import SectionRow from '../SectionRow';
import { TrialProgram } from '@/api/apis/facilities/trial-programs';
import { RandomizationResultsButton } from './RandomizationResultsButton';
import { getRandomizationResultState } from '@/utils/helpers';

type RandomizationResultsProps = {
  organApproval?: OrganApproval | null;
  trialProgram: TrialProgram;
  txCenterDetails?: CaseFacility;
  randomization?: Randomization;
  questionnaire?: TrialAnsweredQuestionModel[] | undefined;
  reallocationData?: ReallocationData | null;
};

export const RandomizationResults = ({
  trialProgram,
  txCenterDetails,
  randomization,
  organApproval,
  questionnaire,
  reallocationData,
}: RandomizationResultsProps) => {
  const isTurndownReallocation = reallocationData?.outcomeData?.outcomeType === OutcomeType.Turndown;
  const showRandomizationFromReallocation = !randomization && isTurndownReallocation;

  const randomizationToUse = showRandomizationFromReallocation ? reallocationData?.randomization : randomization;
  const questionnaireToUse = showRandomizationFromReallocation ? reallocationData?.questionnaire : questionnaire;
  const hasOrganApproval = showRandomizationFromReallocation ? true : !!organApproval;

  const { hasRandomizationResult, randomizationNotNeeded } = getRandomizationResultState(
    randomizationToUse,
    questionnaireToUse,
    trialProgram.organ,
    hasOrganApproval,
  );
  const showRandomizationInfo = hasRandomizationResult || randomizationNotNeeded;

  if (!showRandomizationInfo) return null;
  return (
    <SectionRow truncate={false} label="Randomization">
      {randomizationNotNeeded && <div className="text-m-m">No Randomization</div>}
      {hasRandomizationResult && (
        <RandomizationResultsButton
          txCenterName={txCenterDetails?.name}
          organ={trialProgram.organ}
          randomization={randomizationToUse}
        />
      )}
    </SectionRow>
  );
};
